import React, { useEffect } from 'react';
import QuestionViewHeaderButton from './QuestionViewHeaderButton';
import { Icon } from '@wegroup/design-system';
import useFeatureFlags from '../../../../../app/src/hooks/useFeatureFlags';
import { useFlowsDispatch } from '../../../../../common/src/utils/globalVariables';
import { setShowBrokerInfoModal } from '../../../../../flows/src/store/redux/slices/flowsMetaDataSlice';
import useHubspotChat from '../../../../../common/src/hooks/tracking/useHubspotChat';
import { isSocialLoginUrl } from '../../../../../app/src/features/authentication/constants/SocialAuth';

const QuestionViewHeaderSupportButton: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const flowsDispatch = useFlowsDispatch();
  const { shutdown, boot, open, getLoadedState } = useHubspotChat();
  const hasLoaded = getLoadedState();

  const { isSupportEnabled } = useFeatureFlags();

  useEffect(() => {
    if (hasLoaded) shutdown();
  }, [hasLoaded]);

  const handleSupportClick = () => {
    if (isSocialLoginUrl) {
      flowsDispatch(setShowBrokerInfoModal(true));
    } else if (isSupportEnabled) {
      if (getLoadedState()) {
        shutdown();
      } else {
        boot();
        open();
      }
    }
  };

  return (
    <QuestionViewHeaderButton
      onClick={handleSupportClick}
      {...{ gridColumn: '-2' }}
    >
      <Icon boxSize={9} name="GeneralActionsQuestion" color="primary.500" />
    </QuestionViewHeaderButton>
  );
};

export default QuestionViewHeaderSupportButton;
